export enum MarketTypes {
	moneyline = '1x2',
	overUnder = 'overUnder',
	bothScore = 'both_score',
	doubleChance = 'double_chance',
}
